import React from 'react';
import { StyledButton, StyledLogo, StyledRateFormContainer, StyledRateLater, StyledX } from './stars.style';
import { ReactComponent as FixelLogo } from './FixelLogo.svg';
import { ReactComponent as X } from './X.svg';
import RatingStars from './Stars';

const RateForm = ({ onClose, onSubmit, showBtn, rank, setRank }) => {
	return (
		<StyledRateFormContainer onSubmit={onSubmit}>
			<StyledX onClick={onClose}>
				<X />
			</StyledX>
			<StyledLogo>
				<FixelLogo />
			</StyledLogo>
			<h2>How Would You Rate Fixel?</h2>
			<h3>Your feedback is important to us!</h3>
			<RatingStars rank={rank} setRank={setRank} />

			{showBtn ? <StyledButton type='submit'>Submit Your Rating</StyledButton> : null}
			<StyledRateLater onClick={onClose}>Rate Us Later</StyledRateLater>
		</StyledRateFormContainer>
	);
};
export default RateForm;
